module.exports = __webpack_public_path__ + "img/setup-dca-dashboard.1bfba56f.jpg";